import React, { useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, CardImg, Col, Container, Label, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import { orders } from "../../common/data";
import { Link } from "react-router-dom";
import avatar4 from "../../assets/images/users/indian_stud_1.jpg";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const StudentReport = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handlePrint = () => {
        window.print();
    };

    const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.text("Student Report", 14, 15);

        autoTable(doc, {
            startY: 20,
            head: [["ID", "Admission ID", "Admission Date", "Full Name", "Class", "Fee Payment Status"]],
            body: orders.map(order => [
                order.id,
                order.orderid,
                order.orderdate,
                order.billingname,
                order.total,
                order.paymentStatus
            ])
        });

        doc.save("student_report.pdf");
    };

    const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(orders);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });

        saveAs(data, "student_report.xlsx");
    };

    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Photo",
                accessor: () => (
                    <CardImg src={avatar4} alt="Brandstrek" className="rounded avatar-md" />
                ),
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Admission ID",
                accessor: "orderid",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Admission Date",
                accessor: "orderdate",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Full Name",
                accessor: "billingname",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Class",
                accessor: "total",
                disableFilters: true,
                filterable: false,
            },
            {
                Header: "Fee Payment Status",
                accessor: (cellProps) => (
                    <span className={`badge bg-${cellProps.paymentStatus === "Paid" ? "success" : cellProps.paymentStatus === "unpaid" ? "warning" : "danger"}-subtle text-${cellProps.paymentStatus.toLowerCase()} text-uppercase`}>
                        {cellProps.paymentStatus}
                    </span>
                ),
                disableFilters: true,
                filterable: true,
            },
            {
                Header: "Action",
                accessor: () => (
                    <>
                        <Link to="/admin/students/view?student=X100001" className="me-3 text-primary"><i className="mdi mdi-eye font-size-18"></i></Link>
                        <Link to="#" className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                        <Link to="#" className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                    </>
                ),
                disableFilters: true,
                filterable: false,
            },
        ],
        []
    );

    const breadcrumbItems = [
        { title: "Students", link: "/" },
        { title: "Reports", link: "#" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Students" breadcrumbItems={breadcrumbItems} />
                    <Card>
                        <CardBody>
                            <Row className="mb-3">
                                <Col lg={2}>
                                    <div className="mb-3">
                                        <Label className="form-label">Class</Label>
                                        <select className="form-control select2">
                                            <option>Select</option>
                                            <option value="EL">Class 1</option>
                                            <option value="FA">Class 2</option>
                                            <option value="FI">Class 3</option>
                                        </select>
                                        <i className="mdi mdi-chevron-down " style={{ position: 'absolute', right: '20px', top: 'calc(50% - 5px)', pointerEvents: 'none' }}></i>
                                    </div>
                                </Col>
                                <Col lg={2}>
                                    <div className="mb-3">
                                        <Label className="form-label">Division</Label>
                                        <select className="form-control select2">
                                            <option>Select</option>
                                            <option value="EL">Div 1</option>
                                            <option value="FA">Div 2</option>
                                            <option value="FI">Div 3</option>
                                        </select>
                                        <i className="mdi mdi-chevron-down " style={{ position: 'absolute', right: '20px', top: 'calc(50% - 5px)', pointerEvents: 'none' }}></i>
                                    </div>
                                </Col>
                                <Col lg={2}>
                                    <div className="mb-3">
                                        <Label className="form-label">House</Label>
                                        <select className="form-control select2">
                                            <option>Select</option>
                                            <option value="EL">Red</option>
                                            <option value="FA">Blue</option>
                                            <option value="FI">Yellow</option>
                                        </select>
                                        <i className="mdi mdi-chevron-down " style={{ position: 'absolute', right: '20px', top: 'calc(50% - 5px)', pointerEvents: 'none' }}></i>
                                    </div>
                                </Col>
                                <Col className="text-end">
                                    <Button color="secondary" onClick={handlePrint} className="me-2">
                                        <i className="mdi mdi-printer"></i> Print
                                    </Button>
                                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="d-inline-block">
                                        <DropdownToggle caret color="primary">
                                            <i className="mdi mdi-export"></i> Export
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem onClick={handleExportPDF}>Export as PDF</DropdownItem>
                                            <DropdownItem onClick={handleExportExcel}>Export as Excel</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </Row>

                            <TableContainer
                                columns={columns || []}
                                data={orders || []}
                                isPagination={false}
                                iscustomPageSize={false}
                                isBordered={false}
                                customPageSize={10}
                                className="custom-header-css table align-middle table-nowrap"
                                tableClassName="table-centered align-middle table-nowrap mb-0"
                                theadClassName="text-muted table-light"
                            />
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default StudentReport;
